import './App.css'


function App(props) {

  // return
  return (
   <div>
        Hello React II
   </div> 
  )
}


export default App;
